<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.bom_version_view')" name="0">
        <InventBomVersionSearch @goBomDiff="goBomDiff"></InventBomVersionSearch>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.bom_version_diff')" name="1">
        <InvetnBomDiff ref="BomDiff"></InvetnBomDiff>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import InventBomVersionSearch from './InventBomVersionSearch.vue';
import InvetnBomDiff from './InvetnBomDiff.vue';

export default {
  components: {
    InventBomVersionSearch,
    InvetnBomDiff
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  methods: {
    goBomDiff(t) {
      this.tab_index = "1";
      this.$refs.BomDiff.BOMVersion1 = t.BOMVersion1;
      this.$refs.BomDiff.BOMVersion2 = t.BOMVersion2;
      this.$refs.BomDiff.getDiff(function () { })
    }
  }
}
</script>
